"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFiles = _interopRequireDefault(require("react-files"));

var _reactSizeme = require("react-sizeme");

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

var _mediaSizes = _interopRequireDefault(require("../../../../../common/constants/mediaSizes"));

require("../styles/_drop-zone.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MIN_FILE_SIZE = 0;
var FILE_SIZE_MULTIPLIER = 10000000000;
var MAX_FILE_SIZE_GB = 10 * FILE_SIZE_MULTIPLIER;

var DropZone = /*#__PURE__*/function (_Component) {
  _inherits(DropZone, _Component);

  function DropZone() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DropZone);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DropZone)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onFilesChange", function (files) {
      var _this$props = _this.props,
          addFileToQueue = _this$props.addFileToQueue,
          closeDropZone = _this$props.closeDropZone;
      Array.from(files).forEach(function (file) {
        addFileToQueue({
          file: file
        });

        _this._filePickerRef.removeFiles();
      });
      closeDropZone();
    });

    _defineProperty(_assertThisInitialized(_this), "setFilePickerRef", function (ref) {
      if (_this._filePickerRef || !ref) {
        return;
      }

      var filePickerRefCallBack = _this.props.filePickerRefCallBack;
      _this._filePickerRef = ref;
      filePickerRefCallBack(ref);
    });

    _defineProperty(_assertThisInitialized(_this), "handleUploadClick", function () {
      if (!_this._filePickerRef) {
        return;
      }

      _this._filePickerRef.openFileChooser();
    });

    return _this;
  }

  _createClass(DropZone, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          isVisible = _this$props2.isVisible,
          handleDragOut = _this$props2.handleDragOut;
      return _react.default.createElement(_reactSizeme.SizeMe, null, function (_ref) {
        var size = _ref.size;
        return _react.default.createElement("div", {
          className: "library-drop-zone__container",
          onDragLeave: handleDragOut
        }, _react.default.createElement(_reactFiles.default, {
          className: (0, _classnames.default)('library-drop-zone', {
            'library-drop-zone--hidden': !isVisible,
            'library-drop-zone--small': size.width < _mediaSizes.default.small
          }),
          dropActiveClassName: "library-drop-zone--active",
          onChange: _this2.onFilesChange,
          onError: console.error,
          accepts: void 0,
          multiple: true,
          maxFileSize: MAX_FILE_SIZE_GB,
          minFileSize: MIN_FILE_SIZE,
          ref: _this2.setFilePickerRef,
          clickable: false
        }, _react.default.createElement("p", {
          className: "library-drop-zone__primary-text"
        }, "Drag & Drop"), _react.default.createElement("p", {
          className: "library-drop-zone__secondary-text"
        }, "Drop any .jpg, .png, .gif, .mp4, .mov or\xA0", _react.default.createElement(_uiKit.LinkButton, {
          onClick: _this2.handleUploadClick
        }, _react.default.createElement("u", {
          className: "library-drop-zone__text-underlined"
        }, "browse your files")))));
      });
    }
  }]);

  return DropZone;
}(_react.Component);

exports.default = DropZone;